'use strict';

var dateFns = require('date-fns');

const getDifferenceIntervals = (a, b) => {
  const result = [];
  if (!dateFns.areIntervalsOverlapping(a, b)) {
    result.push(a);
  } else {
    if (dateFns.isAfter(b.start, a.start)) {
      result.push({ start: a.start, end: b.start });
    }
    if (dateFns.isBefore(b.end, a.end)) {
      result.push({ start: b.end, end: a.end });
    }
  }
  return result;
};

module.exports = getDifferenceIntervals;
//# sourceMappingURL=getDifferenceIntervals.cjs.map
